<template>
  <footer id="footer">
    <div class="container">
      <div class="conter-inner">
        <div
          class="row"
          v-if="
                        general.address_list && general.address_list.length > 0
                    "
        >
          <div class="col-md-4" v-for="(address, index) in general.address_list" :key="index">
            <div class="footer-item">
              <h3 class="text-uppercase font-balo font-bold">{{ address.name }}</h3>
              <div class="info" v-html="address.information"></div>
            </div>
          </div>
        </div>
        <div class="footer-bottom relative-section">
          <div class="list-inline">
            <div class="item-inline menu-footer menu-footer-mobile" v-if="menuFooter.length">
              <ul>
                <li v-for="(item, index) in menuFooter" :key="index">
                  <a :href="generateRouter(item)" v-html="item.title"></a>
                </li>
              </ul>
            </div>
            <div class="item-inline">
              <router-link to="/" class="logo-footer">
                <img :src="general.logo_footer" alt v-if="general.logo_footer" />
                <img v-if="!general.logo_footer" src="../assets/images/logo/logo.png" alt />
              </router-link>
            </div>
            <div class="item-inline menu-footer menu-footer-table" v-if="menuFooter.length">
              <ul>
                <li v-for="(item, index) in menuFooter" :key="index">
                  <a :href="generateRouter(item)" v-html="item.title"></a>
                </li>
              </ul>
            </div>
          </div>
          <div class="socials">
            <a v-if="general.facebook_link" :href="general.facebook_link" target="_blank">
              <img src="../assets/images/facebook.svg" alt />
            </a>
            <a v-if="general.twitter_link" :href="general.twitter_link" target="_blank">
              <img src="../assets/images/twitter.svg" alt />
            </a>
            <a v-if="general.youtube_link" :href="general.youtube_link" target="_blank">
              <img src="../assets/images/youtube.svg" alt />
            </a>
            <a v-if="general.instagram_link" :href="general.instagram_link" target="_blank">
              <img src="../assets/images/instagram.svg" alt />
            </a>
          </div>
          <div class="copyright font-bai">{{ general.copyright }}</div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex";
import { get } from "lodash";
export default {
  name: "FooterComponent",
  computed: {
    ...mapState({
      lang: state => get(state, "app.lang", false),
      general: state => get(state, "app.general", {}),
      menuFooter: state => get(state, "app.menu.menuFooter", [])
    })
  },
  methods: {
    generateRouter(item) {
      let path = item.path;
      if (item.object === "page") {
        path = `/page${item.path}`;
      }
      return path;
    }
  }
};
</script>
